import { graphql } from "@/gql";

export const INCIDENT_QUERY = graphql(`
  query INCIDENT_QUERY($id: String!) {
    incident(id: $id) {
      id
      shortId
      organizationId
      organization {
        id
        name
        logoUrl
        groups {
          nodes {
            id
            name
          }
        }
        members {
          nodes {
            id
            displayName
            fullName
          }
        }
      }
      updatedAt
      createdAt
      firstResponseAt
      resolutionAt
      priority
      status
      subject
      description
      additionalData
      submittedByMemberId
      submittedByMember {
        id
        fullName
        displayName
        avatarUrl
      }
      contactMemberId
      contactMember {
        id
        fullName
        displayName
        avatarUrl
        emailAddress
        phoneNumber
        lastActiveAt
      }
      ownedByMemberId
      ownedByMember {
        id
        fullName
        displayName
        avatarUrl
      }
      ownedByGroupId
      ownedByGroup {
        id
        name
      }
      livestreams {
        nodes {
          id
          status
          memberId
        }
      }
      incidentType {
        id
        name
        dataSchema
        uiSchema
        iconSvg
        allowDroneEndpoint
        category
      }
      ...INICDENT_UPDATES_FRAGMENT
      ...INCIDENT_DETAILS_FRAGMENT
      ...INICDENT_INFORMATION_FRAGMENT
      ...INICDENT_CONTACT_FRAGMENT
      ...INCIDENT_LOCATION_FRAGMENT
    }
  }
`);

export const INICDENT_INFORMATION_FRAGMENT = graphql(`
  fragment INICDENT_INFORMATION_FRAGMENT on Incident {
    id
    priority
    status
    resolutionAt
    firstResponseAt
    createdAt
    updatedAt
    contactMember {
      id
      organizationId
      displayName
      fullName
      avatarUrl
      lastActiveAt
    }
    ownedByMemberId
    ownedByMember {
      id
      organizationId
      displayName
      fullName
      avatarUrl
      lastActiveAt
    }
    ownedByGroupId
    ownedByGroup {
      id
      organizationId
      name
    }
    incidentType {
      id
      name
      iconSvg
      category
    }
  }
`);

export const INICDENT_UPDATES_FRAGMENT = graphql(`
  fragment INICDENT_UPDATES_FRAGMENT on Incident {
    id
    shortId
    organizationId
    incidentType {
      id
      uiSchema
      dataSchema
    }
    incidentUpdates {
      nodes {
        id
        type
        message
        createdAt
        previousValue
        updatedValue
        isSystemMessage
        performedByMember {
          id
          fullName
          displayName
          avatarUrl
        }
        attachments {
          nodes {
            id
            mimetype
            url
            filename
            createdAt
          }
        }
      }
    }
  }
`);

export const INCIDENT_DETAILS_FRAGMENT = graphql(`
  fragment INCIDENT_DETAILS_FRAGMENT on Incident {
    id
    shortId
    organizationId
    contactMember {
      id
      organizationId
      displayName
      fullName
      avatarUrl
      lastActiveAt
    }
    subject
    description
    additionalData
    incidentType {
      id
      name
      dataSchema
      uiSchema
    }
  }
`);

export const INICDENT_CONTACT_FRAGMENT = graphql(`
  fragment INICDENT_CONTACT_FRAGMENT on Incident {
    id
    shortId
    organizationId
    contactMemberId
    contactMember {
      id
      organizationId
      displayName
      fullName
      avatarUrl
      lastActiveAt
      emailAddress
      phoneNumber
      metadata
      timezone
      emergencyContacts {
        nodes {
          id
          description
          phoneNumber
          priority
        }
      }
    }
    organization {
      id
      memberMetadataFields
    }
  }
`);

export const INCIDENT_LOCATION_FRAGMENT = graphql(`
  fragment INCIDENT_LOCATION_FRAGMENT on Incident {
    id
    shortId
    organizationId
    incidentCoordinates {
      x
      y
    }
    incidentCoordinatesGeocode {
      id
      address
      plusCode
    }
    submittedByMemberCoordinates {
      x
      y
    }
    places {
      nodes {
        id
        name
        radius
        spatialData {
          geojson
        }
      }
    }
    organization {
      id
      places {
        nodes {
          id
          name
          radius
          spatialData {
            geojson
          }
        }
      }
    }
  }
`);
